module.exports = __webpack_public_path__ + "static/media/playIcon.651458f9.svg";